// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"229":"bbebc253","332":"afe1b189","336":"e2214a9c","404":"dc940817","772":"01700ed0","792":"46c7b2fa","892":"3c755061"}[chunkId] + ".chunk.css";
};